import React, { useEffect, useState } from 'react';
import '../../../styles/components/management/steps/StepNavigator.css';

const API_BASE = process.env.REACT_APP_API_BASE;

export default function StepNavigator({
  unitId,
  activeStep,
  onSelectStep,
  onAddStep,
  onEditStep,
  onDeleteStep
}) {
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    if (!unitId) return;

    const fetchSteps = async () => {
      try {
        const res = await fetch(
          `${API_BASE}/app/API/rbmgt/unit_step.php?unit_id=${unitId}`
        );
        const data = await res.json();

        if (data.success && Array.isArray(data.steps)) {
          const sorted = data.steps.slice().sort((a, b) => a.STEP_ORDER - b.STEP_ORDER);
          setSteps(sorted);

          if (!activeStep && sorted.length) {
            const firstInc = sorted.find(s => s.is_completed === 0);
            onSelectStep(firstInc ? firstInc.STEP_TEMPLATE_ID : sorted[0].STEP_TEMPLATE_ID);
          }
        }
      } catch (err) {
        console.error('Failed to fetch steps:', err);
      }
    };

    fetchSteps();
  }, [unitId, activeStep, onSelectStep]);

  return (
    <div className="step-nav-wrapper">
      <ul className="step-nav">
        {steps.map(step => {
          const isActive = step.STEP_TEMPLATE_ID === activeStep;
          const classes = ['step-item'];
          if (isActive) classes.push('active');
          if (step.is_completed) classes.push('completed');

          return (
            <li
              key={step.STEP_TEMPLATE_ID}
              className={classes.join(' ')}
              onClick={() => onSelectStep(step.STEP_TEMPLATE_ID)}
            >
              <span className="step-dot" style={{ backgroundColor: step.COLOR }}>
                {step.STEP_ORDER}
              </span>

              <div className="step-text">
                <div className="step-title">{step.TITLE}</div>
                <div className="step-desc">{step.DESCRIPTION}</div>
              </div>

              <button
                className="step-btn edit"
                onClick={e => {
                  e.stopPropagation();
                  onEditStep(step);
                }}
              >
                ✏️
              </button>

              <button
                className="step-btn delete"
                onClick={e => {
                  e.stopPropagation();
                  onDeleteStep(step.STEP_TEMPLATE_ID);
                }}
              >
                🗑️
              </button>
            </li>
          );
        })}
      </ul>

      <button className="add-step-btn" onClick={onAddStep}>
        ➕ Add Step
      </button>
    </div>
  );
}
